/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dd_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How are leap years and month lengths handled?`)
};

const es_dd_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo se tratan los años bisiestos y las longitudes de los meses?`)
};

const de_dd_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie werden Schaltjahre und Monatslängen behandelt?`)
};

const nl_dd_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe worden schrikkeljaren en maandlengtes verwerkt?`)
};

const fr_dd_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment les années bissextiles et les longueurs des mois sont-elles gérées?`)
};

const it_dd_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come vengono gestiti gli anni bisestili e la lunghezza dei mesi?`)
};

const pt_br2_dd_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como anos bissextos e comprimentos de meses são tratados?`)
};

const pt_dd_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como são tratados os anos bissextos e os comprimentos dos meses?`)
};

const ja_dd_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`閏年と月の長さはどのように処理されますか？`)
};

const zh_dd_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`闰年和每月天数是如何处理的？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dd_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dd_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dd_faq3_q", locale)
	if (locale === "en") return en_dd_faq3_q(inputs)
	if (locale === "es") return es_dd_faq3_q(inputs)
	if (locale === "de") return de_dd_faq3_q(inputs)
	if (locale === "nl") return nl_dd_faq3_q(inputs)
	if (locale === "fr") return fr_dd_faq3_q(inputs)
	if (locale === "it") return it_dd_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_dd_faq3_q(inputs)
	if (locale === "pt") return pt_dd_faq3_q(inputs)
	if (locale === "ja") return ja_dd_faq3_q(inputs)
	return zh_dd_faq3_q(inputs)
};